export enum SensorType {
  ADMIN_NUMERIC_PASSWORD = 'ADMIN_NUMERIC_PASSWORD',
  ALARM_CARBON_MONOXIDE = 'ALARM_CARBON_MONOXIDE',
  ALARM_FLOOD = 'ALARM_FLOOD',
  ALARM_FLOOD_CH1 = 'ALARM_FLOOD_CH1',
  ALARM_FLOOD_CH2 = 'ALARM_FLOOD_CH2',
  ALARM_FLOOD_CH3 = 'ALARM_FLOOD_CH3',
  ALARM_FLOOD_CH4 = 'ALARM_FLOOD_CH4',
  ALARM_MOTION = 'ALARM_MOTION',
  ALARM_MOTION_CH1 = 'ALARM_MOTION_CH1',
  ALARM_MOTION_CH2 = 'ALARM_MOTION_CH2',
  ALARM_MOTION_CH3 = 'ALARM_MOTION_CH3',
  ALARM_MOTION_CH4 = 'ALARM_MOTION_CH4',
  ALARM_SMOKE = 'ALARM_SMOKE',
  ALARM_TAMPER = 'ALARM_TAMPER',
  BATTERY = 'BATTERY',
  CARBON_DIOXIDE = 'CARBON_DIOXIDE',
  COLOR = 'COLOR',
  CUBICMETERS_ACCUMULATED = 'CUBICMETERS_ACCUMULATED',
  CUBICMETERS_HOUR = 'CUBICMETERS_HOUR',
  CURRENT = 'CURRENT',
  CURRENT_CH1 = 'CURRENT_CH1',
  CURRENT_CH2 = 'CURRENT_CH2',
  CURRENT_CH3 = 'CURRENT_CH3',
  DIMMER = 'DIMMER',
  DOOR = 'DOOR',
  DOOR_CH1 = 'DOOR_CH1',
  DOOR_CH2 = 'DOOR_CH2',
  DOOR_CH3 = 'DOOR_CH3',
  DOOR_CH4 = 'DOOR_CH4',
  HUMIDITY = 'HUMIDITY',
  ILLUMINANCE = 'ILLUMINANCE',
  KILOWATTSHOUR = 'KILOWATTSHOUR',
  KILOWATTSHOUR_HOUR_CH1 = 'KILOWATTSHOUR_HOUR_CH1',
  KILOWATTSHOUR_HOUR_CH2 = 'KILOWATTSHOUR_HOUR_CH2',
  KILOWATTSHOUR_HOUR_CH3 = 'KILOWATTSHOUR_HOUR_CH3',
  KILOWATTSHOUR_ACCUMULATED = 'KILOWATTSHOUR_ACCUMULATED',
  KILOWATTSHOUR_ACCUMULATED_CH1 = 'KILOWATTSHOUR_ACCUMULATED_CH1',
  KILOWATTSHOUR_ACCUMULATED_CH2 = 'KILOWATTSHOUR_ACCUMULATED_CH2',
  KILOWATTSHOUR_ACCUMULATED_CH3 = 'KILOWATTSHOUR_ACCUMULATED_CH3',
  LITERS_ACCUMULATED = 'LITERS_ACCUMULATED',
  LITERS_HOUR = 'LITERS_HOUR',
  LOCK = 'LOCK',
  LOCK_3_POSITIONS = 'LOCK_3_POSITIONS',
  LUMEN = 'LUMEN',
  LUX = 'LUX',
  NFC_CODE = 'NFC_CODE',
  NUMERIC_PASSWORD = 'NUMERIC_PASSWORD',
  PARTICULATE_MATTER25 = 'PARTICULATE_MATTER2.5',
  PEOPLE_FLOW_IN = 'PEOPLE_FLOW_IN',
  PEOPLE_FLOW_OUT = 'PEOPLE_FLOW_OUT',
  PEOPLE_COUNTER = 'PEOPLE_COUNTER',
  POWERFACTOR = 'POWERFACTOR',
  POWERFACTOR_CH1 = 'POWERFACTOR_CH1',
  POWERFACTOR_CH2 = 'POWERFACTOR_CH2',
  POWERFACTOR_CH3 = 'POWERFACTOR_CH3',
  PUSHBUTTON = 'PUSHBUTTON',
  QR_CODE = 'QR_CODE',
  SHUTTER = 'SHUTTER',
  SLATS = 'SLATS',
  SWITCH = 'SWITCH',
  SWITCH_CH1 = 'SWITCH_CH1',
  SWITCH_CH2 = 'SWITCH_CH2',
  SWITCH_CH3 = 'SWITCH_CH3',
  SWITCH_CH4 = 'SWITCH_CH4',
  TEMPERATURE = 'TEMPERATURE',
  TEMPERATURE_CH1 = 'TEMPERATURE_CH1',
  TEMPERATURE_CH2 = 'TEMPERATURE_CH2',
  TEMPERATURE_CH3 = 'TEMPERATURE_CH3',
  TEMPERATURE_CH4 = 'TEMPERATURE_CH4',
  THERMOSTAT_FAN_MODE = 'THERMOSTAT_FAN_MODE',
  THERMOSTAT_MODE = 'THERMOSTAT_MODE',
  THERMOSTAT_OPERATING_STATE = 'THERMOSTAT_OPERATING_STATE',
  THERMOSTAT_SETPOINT = 'THERMOSTAT_SETPOINT',
  THERMOSTAT_SETPOINT_COOLING = 'THERMOSTAT_SETPOINT_COOLING',
  THERMOSTAT_SETPOINT_HEATING = 'THERMOSTAT_SETPOINT_HEATING',
  VIRTUAL_PRESENCE = 'VIRTUAL_PRESENCE',
  VOLATILE_ORGANIC_COMPOUND = 'VOLATILE_ORGANIC_COMPOUND',
  VOLTAGE = 'VOLTAGE',
  VOLTAGE_CH1 = 'VOLTAGE_CH1',
  VOLTAGE_CH2 = 'VOLTAGE_CH2',
  VOLTAGE_CH3 = 'VOLTAGE_CH3',
  WATTS = 'WATTS',
  WATTS_INSTANTANEOUS_CH1 = 'WATTS_INSTANTANEOUS_CH1',
  WATTS_INSTANTANEOUS_CH2 = 'WATTS_INSTANTANEOUS_CH2',
  WATTS_INSTANTANEOUS_CH3 = 'WATTS_INSTANTANEOUS_CH3',
  WIFI = 'WIFI',
}

export enum SensorUsage {
  AC = 'AC',
  ALARM = 'ALARM',
  ALARM_ENABLE = 'ALARM_ENABLE',
  BOILER = 'BOILER',
  COMMUNITY_DOOR = 'COMMUNITY_DOOR',
  DOOR = 'DOOR',
  DOORBELL = 'DOORBELL',
  EXTRACTOR = 'EXTRACTOR',
  FAN = 'FAN',
  FIRE = 'FIRE',
  FLOOD = 'FLOOD',
  HOME_APPLIANCES = 'HOME_APPLIANCES',
  INFO_SENSOR = 'INFO_SENSOR',
  LIGHT = 'LIGHT',
  LOCAL = 'LOCAL',
  MOTION = 'MOTION',
  PUMP = 'PUMP',
  REMOTE = 'REMOTE',
  ROLLER = 'ROLLER',
  SLATS = 'SLATS',
  SOCKET = 'SOCKET',
  SIREN = 'SIREN',
  SWITCH = 'SWITCH',
  VALVE_GAS = 'VALVE_GAS',
  VALVE_UNDERFLOOR_HEATING = 'VALVE_UNDERFLOOR_HEATING',
  VALVE_WATER = 'VALVE_WATER',
  WINDOW = 'WINDOW',
}
